<template>
  <div class="animated fadeIn">

    <!-- && (NOACCESS || emailNoValidated)"  -->
    <div v-if="client.id" class="register-title mb-5 mt-4 text-center">
      <EmailValidateAlert v-if="emailNoValidated" />
      <PhoneValidateAlert v-if="phoneNoValidated" />
      <CreditCardValidateAlert v-if="creditCardNoValidated"/>
    </div>

    <BillingData2
      v-bind:client="client"
      :loading="loading"
      @updateClient="updateClientDataInvoice"
      v-on:toggle-company="client.billing_identification_type = $event ? 'empresa': 'particular' "
      v-on:toggle-billing-data="setClientBilling($event)"
    />


    <!-- <BillingData
      v-bind:client="client"
      @updateClient="showModalNew = $event"
      v-on:toggle-company="client.billing_company = $event, client.billing_identification_type = $event ? 'empresa': 'particular' "
      v-on:toggle-billing-data="setClientBilling($event)"
    /> -->

    <toast ref="toast"></toast>
  </div>
</template>


<script>

import { updateBillingData } from '@/app/shared/global/services/client-service';
// import { getLoggedClient } from '@/app/views/auth/shared/services';
import { fetchOneClient} from '@/app/views/clientes/shared/services';
// import BillingData from "@/app/views/clientes/shared/components/BillingData";
import BillingData2 from "@/app/views/clientes/shared/components/BillingData2";

import { noEmail, noPhone, noCreditCard } from '@/app/shared/utils/utils';


export default {
  name: "ClientBillingData",
  components: {
    // BillingData,
    BillingData2,
    EmailValidateAlert: () => import('@/app/shared/components/EmailValidateAlert'),
    PhoneValidateAlert: () => import('@/app/shared/components/PhoneValidateAlert'),
    CreditCardValidateAlert: () => import('@/app/shared/components/CreditCardValidateAlert')
  },
  data() {
    return {
      userLogged: null,
      paramsID: localStorage.getItem('user_id'),
      elemento: "Datos de Facturación",
      loading: true,
      message: null,
      client: {},
      clientToEdit: null,
      submitted:false,
    };
  },
  mounted() {
    if (this.$route.query && this.$route.query.expired) {
      this.$refs.toast.showToast('La sesión ha caducado. Por favor, inicie sesión de nuevo.', null,"error","5000");
    }
  },
  async created() {
    this.getClientLogged();
  },
  computed: {
    emailNoValidated(){
      return noEmail(this.client);
    },
    creditCardNoValidated() {
      return noCreditCard(this.client);
    },
    phoneNoValidated() {
      return noPhone(this.client);
    },
  },

  methods: {

    updateClientDataInvoice(value) {
      this.updateBillingData(value);
    },

    resetForm() {
      this.loading = false;
    },

    setClientBilling(value) {
      this.client.billing_name = value ?
        this.clientToEdit.name + " " + this.clientToEdit.surnames
        : this.clientToEdit.billing_name;
    },

    updateBillingData(billingData) {

      const errorMessage = `Error al actualizar tus ${this.elemento.toLowerCase()}`;
      this.loading = true;

      updateBillingData(billingData)
        .then((resp) => {

          if (resp?.status !== "success") {
            this.$refs.toast.showToast(errorMessage, null, "error","5000")
            return;
          }

          this.$refs.toast.showToast(`${this.elemento} actualizados correctamente`, null, "success","5000");
        })
        .catch((err) => {
          // console.log(err);
          this.$refs.toast.showToast(`${errorMessage} - ${err?.status}`, null, "error","5000");
        })
        .finally(() => {
          this.resetForm();
          this.getClientLogged();
        });

    },


    async getClientLogged() {

      try {

        this.loading = true;
        let resp = await fetchOneClient(this.paramsID);
        // let resp = await getLoggedClient();

        if (resp.status !== 'success') {
          this.$refs.toast.showToast(  `Se ha producido un error al cargar ${resp.data.message} `, null, "error", "5000");
          this.loading = false;
          return
        }

        this.clientToEdit = resp.data;

        this.client = { ...this.clientToEdit };
        this.client.company = this.client.billing_identification_type === 'empresa' ? true : false;

        this.loading = false;

      } catch(e) {
        // console.log(e);
        this.loading = false;

        this.$refs.toast.showToast( 'Se ha producido un error al cargar', null, "error", "5000");
      }
    },



  }
};
</script>

<style lang="scss" scoped>

</style>
